import type { EditorState } from "@linempo/editor-session";
import { animationForAsset, animationGeometryKey } from "@linempo/project-domain";

/** Derive display state here; the shared UI never reads the editor session. */
export function animationView(state: EditorState, assetId: string) {
  const animation = state.project && animationForAsset(state.project, assetId);
  return animationViewForId(state, animation?.id ?? null);
}

/** A legacy placed scene can reference a different definition of the same asset. */
export function animationViewForId(state: EditorState, animationId: string | null) {
  const animation = state.project?.animations.find((item) => item.id === animationId);
  const busy = state.generation.status === "running" || state.generation.status === "cancelling";
  if (!animation || !state.project) return { animationId: null, status: "missing" as const, busy };
  const job = state.generation.items.find((item) => item.animationId === animation.id);
  const key = animationGeometryKey(state.project, animation.id);
  const ready = state.animations.inspections.some((item) => item.animationId === animation.id && item.status === "ready" && item.inputKey === key) || (job?.status === "completed" && job.result?.inputKey === key && job.result.animationId === animation.id);
  const status = job?.status === "running" || job?.status === "queued" ? job.status : ready ? "ready" : job?.status === "failed" ? "failed" : job?.status === "cancelled" ? "cancelled" : "missing";
  return { animationId: animation.id, status, busy } as const;
}

export const animationBadge = (status: ReturnType<typeof animationView>["status"]) => ({ missing: "待生成", queued: "排队中", running: "生成中", ready: "已生成", failed: "生成失败", cancelled: "已取消" })[status];
export const elapsed = (ms: number) => ms < 60_000 ? `${Math.floor(ms / 1000)} 秒` : `${Math.floor(ms / 60_000)} 分 ${Math.floor(ms % 60_000 / 1000)} 秒`;

export function generationCounts(batch: EditorState["generation"]) {
  const succeeded = batch.items.filter((item) => item.status === "completed").length;
  const failed = batch.items.filter((item) => item.status === "failed").length;
  const cancelled = batch.items.filter((item) => item.status === "cancelled").length;
  return { succeeded, failed, cancelled, processed: succeeded + failed + cancelled };
}
